import { useMemo } from "react";
import { Link } from "react-router-dom";
import Button from "../../components/Button/Button";
import { FaSearch, FaCalendarAlt } from "react-icons/fa";

import Loader from "../../components/Loader/Loader";
import Table from "../../components/Table/Table";
import Pagination from "../../components/Pagination/Pagination";

import AssessmentFilter from "../AssessmentMarking/AssessmentFilter";
import { tableConstants } from "./ExamConfigTableConstant";
import "../Exam/Exam.css";

import { useExamConfigList } from "./hooks/useExamConfigList";

const ExamConfigList = () => {
  const {
    examConfigData,
    subjectData,
    examList,
    programData,
    evaluationTypes,
    programs,

    filters,
    onFilterChange,
    resetFilters,

    isLoader,
    advancedSearch,
    toggleAdvancedSearch,

    perPage,
    currentPage,
    lastPage,
    searchMode,

    loadExamConfigList,
    searchExamConfigList,
    deleteExam,
    onProgramSelect,
    onProgramRemove,
  } = useExamConfigList();

  const permissions = useMemo(
    () => JSON.parse(localStorage.getItem("permissions")),
    []
  );
  const cols = useMemo(
    () => tableConstants(deleteExam, permissions, currentPage, perPage),
    [deleteExam, permissions, currentPage, perPage]
  );
  return (
    <div className="card">
      {isLoader ? (
        <Loader />
      ) : (
        <>
          {/* Header */}
          <div className="card-header d-flex justify-content-between">
            <div className="d-flex align-items-center gap-3">
              <span className="main-title-page d-flex align-items-center">
                <span className="mx-2"><FaCalendarAlt /></span>
                <span>Exam Configuration</span>
              </span>
              <Button variant="success" onClick={toggleAdvancedSearch}>
                <FaSearch /> Search
              </Button>
            </div>

            <div>
              {/* {permissions?.includes("exams.config.bulk.create") && (
                <Link className="btn btn-primary" to="/bulk/exam/config/create">
                  Exam Config Bulk Create
                </Link>
              )} */}
              {permissions?.includes("exam.config.create") && (
                <Link className="btn btn-primary mx-2" to="/exam/config/create">
                  Add
                </Link>
              )}
            </div>
          </div>

          {/* Filters */}
          <div className={`filter-event ${advancedSearch ? 'show' : 'hide'}`} id="advanced-search">
            <AssessmentFilter
              evaluationType={evaluationTypes}
              programData={programData}
              subjectData={subjectData}
              examList={examList}
              programs={programs}
              onProgramSelect={onProgramSelect}
              onRemove={onProgramRemove}
              onChangeHandler={onFilterChange}
              statusData={[
                { id: 1, name: "Not Graded" },
                { id: 2, name: "In Progress" },
                { id: 3, name: "Graded" },
              ]}
              {...filters}
              handleSearch={(page) => searchExamConfigList(page.selected + 1)}
              handleReset={resetFilters}
            />
          </div>
          {/* Table */}
          <div className="card-body">
            {examConfigData.length > 0 ? (
              <div className="evaluating-table event-tablecus">
                <Table
                  cols={cols}
                  data={examConfigData}
                  hoverable
                  striped
                />
              </div>
            ) : (
              <div className="text-center">No data found</div>
            )}
          </div>
          {/* Pagination */}
          {examConfigData.length > 0 && (
            <div className="card-footer">
              <Pagination
                totalPage={lastPage}
                currentPage={currentPage - 1}
                handlePageChange={(page) =>
                  searchMode
                    ? searchExamConfigList(page.selected + 1)
                    : loadExamConfigList(page.selected + 1)
                }
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ExamConfigList;
